import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";

// FIX 1: Changed "contact" to "Contact" (Capital C)
const Contact = () => {
  const form = useRef();
  const [status, setStatus] = useState('');

  const sendEmail = (e) => {
    e.preventDefault();
    setStatus('Sending...');

    // These are your specific IDs from EmailJS
    const serviceID = 'service_3bwrozo';
    const templateID = 'template_omebk1o'; // Ensure this matches your EmailJS dashboard exactly
    const publicKey = '-YNBsZMFHNehis27Y';

    emailjs.sendForm(serviceID, templateID, form.current, publicKey)
      .then((result) => {
          console.log("SUCCESS!", result.status, result.text);
          setStatus('Success! Your message has been sent to help@helpin.in.');
          e.target.reset(); 
      }, (error) => {
          console.error("FAILED...", error);
          setStatus(`Failed: ${error.text || 'Check your Template ID'}`);
      });
  };

  return (
    <Container style={{ marginTop: '50px', maxWidth: '600px' }}>
      <Card className="shadow-sm">
        <Card.Body>
          <Card.Title className="text-center mb-4">
            <h2>Contact us</h2>
            <h5>Write you queries here - HELP us to HELP you.</h5>
          </Card.Title>
          
          <Form ref={form} onSubmit={sendEmail}>
            <Form.Group className="mb-3">
              <Form.Label>Your Name</Form.Label>
              <Form.Control 
                type="text" 
                name="user_name" 
                placeholder="Enter your full name" 
                required 
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Email Address</Form.Label>
              <Form.Control 
                type="email" 
                name="user_email" 
                placeholder="name@example.com" 
                required 
              />
            </Form.Group>

            {/* NEW MOBILE NUMBER FIELD */}
              <Form.Group className="mb-3">
              <Form.Label>Mobile Number</Form.Label>
              <Form.Control type="tel" name="user_mobile" placeholder="Enter your 10-digit mobile number"  pattern="[0-9]{10}" // Optional: ensures they enter 10 digits
               required />
            </Form.Group>

              {/* NEW CATEGORY SELECTION */}
            <Form.Group className="mb-3">
              <Form.Label>I am a:</Form.Label>
              <div>
                <Form.Check inline label="Volunteer" name="user_type" type="radio" value="Volunteer" />
                <Form.Check inline label="Donor" name="user_type" type="radio" value="Donor" />
                <Form.Check inline label="Help Seeker" name="user_type" type="radio" value="Seeking Help" required />
              </div>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Message</Form.Label>
              <Form.Control 
                as="textarea" 
                name="message" 
                rows={4} 
                placeholder="How can we help you?" 
                required 
              />
            </Form.Group>

            <div className="d-grid gap-2">
              <Button variant="primary" type="submit">
                Send Message
              </Button>
            </div>
          </Form>

          {status && (
            <div className={`mt-3 p-2 text-center rounded ${status.includes('Success') ? 'bg-success text-white' : 'bg-danger text-white'}`}>
              {status}
            </div>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
};

// FIX 2: Changed export to "Contact" (Capital C)
export default Contact;